export default {
    error: {
        abort_403_message: '访问被拒绝。您可能没有访问此页面的适当权限。',
        abort_403_text: '没有权限',
        abort_404_message: '您正在寻找的页面可能已被删除、更改名称或暂时不可用。',
        abort_404_text: '页面未找到',
        something_went_wrong: '出错了！',
        required: {
            address_in_cambodia: '地址为必填项',
            email: '电子邮件为必填项',
            first_name: '名字为必填项',
            gender: '性别为必填项',
            identity_date: '身份证签发日期为必填项',
            identity_image_back: '身份证背面照片为必填项',
            identity_image_front: '身份证正面照片为必填项',
            identity_issued_date: '身份证签发日期为必填项',
            identity_number: '身份证号码为必填项',
            last_name: '姓氏为必填项',
            nationality: '国籍为必填项',
            passport_image_front: '护照正面照片为必填项',
            passport_image_back: '护照背面照片为必填项',
            passport_number: '护照号码为必填项',
            password: '密码为必填项',
        },
        saving: '保存出错'
    },
    label: {
        about: "关于我们",
        action: "操作",
        add: "添加",
        address: "地址",
        address_in_cambodia: "柬埔寨地址",
        admin_dashboard: "管理员仪表板",
        agree_to: "我同意",
        all: "全部",
        already_have_account: "已有账户？登录。",
        amendment: "修改",
        amendment_date: "申请延期日期",
        amendment_office: "申请更改边境口岸",
        amount: "金额",
        app_dashboard: "应用仪表板",
        app_name: "e-Customs",
        application: "申请表",
        application_report: "申请报告",
        applications: "申请表",
        approve: "批准",
        approve_changed_border_gate: "批准更改边境口岸",
        approve_extended_date_of_entry: "批准延长入境日期",
        approve_extended_date_of_exit: "批准延长出境日期",
        asterisk: "必填",
        attachment: "附件",
        back: "返回",
        back_side: "背面",
        between: "之间",
        border_pass_date: "边境通行证签发日期",
        border_pass_number: "边境通行证号码",
        brand: "品牌",
        browse_your_device: "浏览您的设备",
        by_user: "由用户",
        change_border_gate_of_entry: "更改入境口岸",
        change_border_gate_of_exit: "更改出境口岸",
        change_image: "更改图片",
        changed_at: "更改时间",
        choose: "选择",
        choose_document: "选择文件",
        choose_driver: "选择驾驶员",
        choose_image: "选择图片",
        choose_vehicle: "选择车辆",
        city: "城市",
        close: "关闭",
        code: "代码",
        collapse: "折叠",
        color: "颜色",
        company_address: "公司地址",
        company_code: "公司代码",
        company_information: "公司信息",
        company_name: "公司名称",
        confirm: "确认",
        confirm_delete: "您确定要删除吗？",
        confirm_password: "确认密码",
        contain: "包含",
        create: "创建",
        create_application: "创建申请",
        created_at: "创建时间",
        criteria: "标准",
        currency: "货币",
        customs_registration: "海关登记",
        dashboard: "仪表板",
        date: "日期",
        declaration: "申报单",
        declaration_chart: "申报图表",
        declaration_status: "我的申请",
        declaration_status_today: "今天的申请",
        declarations: "申报单",
        decline: "拒绝",
        decline_changed_border_gate: "拒绝更改边境口岸",
        decline_extended_date_of_entry: "拒绝延长入境日期",
        decline_extended_date_of_exit: "拒绝延长出境日期",
        delete: "删除",
        delete_success: "删除成功",
        deleted_at: "删除时间",
        description: "描述",
        destination: "目的地",
        destination_assess: "目的地评估",
        destination_change: "目的地已更改",
        destination_office_code: "目的地办公室代码",
        destination_office_date: "目的地日期",
        destination_office_name: "目的地办公室",
        destination_assess_status: "目的地评估状态",
        document_size: "文档大小必须小于或等于5MB。",
        dont_have: "没有",
        download: "下载",
        driver: "驾驶员",
        driver_information: "驾驶员信息",
        drivers: "驾驶员",
        driving_license: "驾驶证",
        driving_license_image_back: "驾驶证背面照片",
        driving_license_image_front: "驾驶证正面照片",
        driving_license_photo: "驾驶证照片",
        edit: "编辑",
        email: "电子邮件",
        empty_data: "无数据显示",
        engine_number: "发动机号码",
        enrouting: "在途中",
        entry: "入境",
        entry_date: "入境日期",
        entry_office_code: "入境办公室代码",
        entry_office_name: "入境办公室名称",
        entry_vehicles: "入境车辆",
        entry_vehicles_today: "今天入境车辆",
        equal: "等于",
        exit: "出境",
        exit_date: "出境日期",
        exit_office_code: "出境办公室代码",
        exit_office_name: "出境办公室名称",
        exit_vehicles: "出境车辆",
        exit_vehicles_today: "今天出境车辆",
        expand: "展开",
        expired_date: "到期日期",
        extended_date_of_entry: "延长入境日期",
        extended_date_of_exit: "延长出境日期",
        female: "女",
        file_name: "文件名",
        filter: "筛选",
        first_name: "名字",
        forgot_password: "忘记密码？",
        frame_number: "车架号",
        fraud: "欺诈",
        from: "从",
        from_date: "从日期",
        front_side: "正面",
        fullname: "姓名",
        gender: "性别",
        greater_than: "大于",
        greater_than_or_equal: "大于或等于",
        guarantee_information: "担保信息",
        guarantee_information_invalid: "担保信息无效",
        have: "有",
        having_passport: "有护照吗？",
        home: "主页",
        i_am_also_a_driver: "您是驾驶员吗？",
        i_am_also_driver: "我也是驾驶员",
        id: "ID",
        identity_card: "身份证",
        identity_card_expired_date: "身份证到期日期",
        identity_card_photo: "身份证照片",
        identity_date: "身份证签发日期",
        identity_image_back: "身份证背面照片",
        identity_image_front: "身份证正面照片",
        identity_number: "身份证号码",
        image_back: "背面照片",
        image_front: "正面照片",
        image_size: "图片大小必须小于或等于2MB。",
        input_information_invalid: "输入信息无效",
        insurance_company_code: "保险公司代码",
        insurance_company_name: "保险公司名称",
        insurance_date: "保险日期",
        insurance_number: "保险号码",
        is_required: "为必填项",
        issued_date: "签发日期",
        last_name: "姓氏",
        leave_page_subtitle: "您有未保存的更改！",
        leave_page_title: "您真的要离开吗？",
        length_of_stay: "停留时间",
        less_than: "小于",
        less_than_or_equal: "小于或等于",
        list: "列表",
        loading: "正在检索数据...",
        lodgement: "递交",
        lodgement_assess: "递交评估",
        lodgement_assess_approve: "递交办公室批准",
        lodgement_assess_reject: "递交办公室拒绝",
        lodgement_office_code: "递交办公室代码",
        lodgement_office_date: "递交日期",
        lodgement_office_name: "递交办公室",
        lodgement_assess_status: "递交评估状态",
        login: "登录",
        login_description: "登录以开始您的会话",
        login_information: "登录信息",
        male: "男",
        months: ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],
        more_info: "更多信息",
        my_profile: "我的资料",
        n0: "序号",
        name: "名称",
        nationality: "国籍",
        next: "下一步",
        no: "否",
        no_application: "您还没有申请",
        no_data: "没有与您的搜索匹配的数据",
        no_image: "无图片",
        no_overstay: "无逾期停留申报",
        no_recently_declaration: "没有最近的申报",
        not_equal: "不等于",
        number: "号码",
        office: "办公室",
        office_code: "办公室代码",
        officer: "官员",
        ok: "确定",
        other: "其他文件",
        other_attachment_title: "附件必须是图片类型且大小小于5MB。",
        other_document: "其他文件",
        other_file_criteria: "允许的文件类型：jpeg、png、jpg、pdf 和大小：10MB",
        other_information: "其他信息",
        over_stay_applications: "逾期停留申报",
        overstay: "逾期停留",
        owner: "车主",
        owner_also_driver: "车主也是驾驶员",
        owner_border_pass: "车主边境通行证",
        owner_confirm: "您是车主吗？",
        owner_information: "车主信息",
        owner_passport: "车主护照",
        passport: "护照",
        passport_date: "护照日期",
        passport_expired_date: "护照到期日期",
        passport_image_back: "护照背面照片",
        passport_issued_date: "护照签发日期",
        passport_number: "护照号码",
        passport_photo: "护照照片",
        password: "密码",
        password_confirmation: "密码确认",
        penalize: "处罚",
        phone: "电话",
        plate_number: "车牌号",
        print: "打印",
        profile: "资料",
        qrcode: "二维码",
        reason: "原因",
        receipt_number: "收据号码",
        recent_declaration: "最近的申报",
        register: "注册",
        register_date: "注册日期",
        register_new_account: "注册新账户",
        register_number: "注册号码",
        register_type: "注册类型",
        register_year: "注册年份",
        reject: "拒绝",
        reload: "重新加载",
        remove: "移除",
        report: "报告",
        request_change: "请求更改",
        request_change_entry_date: "请求更改入境日期",
        request_change_entry_office: "请求更改入境办公室",
        request_change_exit_date: "请求更改出境日期",
        request_change_exit_office: "请求更改出境办公室",
        request_changed_border_gate: "请求更改边境口岸",
        request_extended_date_of_entry: "请求延长入境日期",
        request_extended_date_of_exit: "请求延长出境日期",
        reset_password: "重置密码",
        resolve: "解决",
        restore: "恢复",
        result: "结果",
        return_home: "返回主页",
        save: "保存",
        save_continue: "保存并继续",
        scan: "扫描",
        search: "搜索",
        search_application: "搜索申请",
        search_driver: "搜索驾驶员",
        search_not_found: "未找到申请",
        search_vehicle: "搜索车辆",
        security_returned: "此担保已退还",
        select: "选择",
        select_driver: "请选择驾驶员",
        select_vehicle: "请选择车辆",
        send: "发送",
        serial: "序列号",
        setting: "设置",
        setup_my_profile: "设置我的资料",
        sign_in: "登录",
        size: "大小",
        status: "状态",
        steer: "方向盘",
        submit: "提交",
        temporary_export: "临时出口",
        temporary_import: "临时进口",
        temporary_vehicle: "临时车辆",
        terms_conditions: "条款和条件",
        timeline: "时间线",
        to: "到",
        to_date: "到",
        today_entry: "今天入境",
        today_exit: "今天出境",
        total_declaration: "申报总数",
        total_vehicle: "车辆总数",
        type: "类型",
        update: "更新",
        update_profile: "更新资料",
        updated_at: "更新时间",
        valid_from: "有效期自",
        valid_to: "有效期至",
        value_1: "值#1",
        value_2: "值#2",
        vehicle: "车辆",
        vehicle_and_driver: "车辆和驾驶员",
        vehicle_chart: "车辆图表",
        vehicle_identitation_back: "车辆识别背面照片",
        vehicle_identitation_front: "车辆识别正面照片",
        vehicle_identity_photo: "车辆证件照片",
        vehicle_information: "车辆信息",
        vehicle_report: "车辆报告",
        vehicle_type: "车辆类型",
        vehicles: "车辆",
        view: "查看",
        view_attachment: "查看附件",
        view_detail: "查看详情",
        view_document: "查看文件",
        view_image: "查看图片",
        year: "年份",
        yes: "是",
        your_email: "您的电子邮件",
        your_information: "您的信息",
        your_password: "您的密码",
        zip: "邮政编码",
        pending: "待处理",
        edit_detail: "编辑详情",
        owners: "车主",
        search_owner: "搜索车主",
        choose_owner: "选择车主",
        select_owner: "请选择车主",
        declined: "已拒绝",
        destination_approved: '目的地办公室已批准',
    },
    message: {
        already_declaration: "已申报！",
        approve_amendment: "您要批准此请求吗？",
        click_to_view: "点击查看附件",
        decline_amendment: "您要拒绝此请求吗？",
        instruction_info: "请点击确定按钮，系统将带您完成信息填写。",
        no_driver: "您还没有驾驶员信息！",
        no_result: "无结果！",
        no_vehicle: "您还没有车辆信息！",
        not_update_passport: "您还没有完成护照信息！",
        not_update_profile: "您还没有更新资料！",
        profile_completion_message: "您的资料尚未完成申请。请设置您的资料！",
        profile_completion_title: "注意！",
        profile_success: "资料保存成功！",
        required_if_no_identity_card: "如果没有身份证，此信息为必填项",
        required_if_no_passport: "如果没有护照，此信息为必填项",
        success: "文件保存成功！",
        verify_phone: "我们将通过此电话号码验证您的账户，请确保它是正确的。",
        please_complete_declaration_owner_first: '请先完成车主信息！',
        owner_success: "车主保存成功！",
        driver_success: "驾驶员保存成功！",
        vehicle_success: "车辆保存成功！",
    },
    validation: {
        attributes: {
            address: "地址",
            address_in_cambodia: "柬埔寨地址",
            attachment: "附件",
            border_pass_date: "边境通行证日期",
            border_pass_number: "边境通行证号码",
            owner_border_pass_number: "边境通行证号码",
            brand: "品牌",
            color: "颜色",
            company_code_v1: "公司代码",
            destination_entry_date: "入境日期",
            destination_entry_office_name: "入境办公室名称",
            destination_exit_date: "出境日期",
            destination_exit_office_name: "出境办公室名称",
            destination_office_code_v1: "目的地办公室代码",
            destination_office_date_v1: "目的地办公室日期",
            destination_office_date_v2: "目的地办公室日期",
            driver_address_in_cambodia: "柬埔寨地址",
            driver_border_pass_date: "边境通行证日期",
            driver_border_pass_number: "边境通行证号码",
            driver_first_name: "名字",
            driver_gender: "性别",
            driver_last_name: "姓氏",
            driver_nationality: "国籍",
            driver_passport_expired_date: "护照到期日期",
            driver_passport_issued_date: "护照签发日期",
            driver_passport_number: "护照号码",
            driving_license_image_back: "驾驶证背面照片",
            driving_license_image_front: "驾驶证正面照片",
            engine_number: "发动机号码",
            entry_date: "入境日期",
            entry_office_name: "入境办公室名称",
            exit_date: "出境日期",
            exit_office_name: "出境办公室名称",
            first_name: "名字",
            frame_number: "车架号",
            fraud_code: "欺诈代码",
            fraud_name: "欺诈名称",
            fraud_valid_from: "欺诈有效期自",
            fraud_valid_to: "欺诈有效期至",
            from_date: "从日期",
            full_name: "姓名",
            fullname: "姓名",
            fullname_v1: "姓名",
            gender: "性别",
            gender_v1: "性别",
            identity_date: "身份证日期",
            identity_date_expire: "身份证到期日期",
            identity_image_back: "身份证背面照片",
            identity_image_front: "身份证正面照片",
            identity_number: "身份证号码",
            identity_v1: "身份证",
            insurance_company_code: "保险公司代码",
            insurance_company_name: "保险公司名称",
            insurance_date: "保险日期",
            insurance_number: "保险号码",
            last_name: "姓氏",
            lodgement_office_code_v1: "递交办公室代码",
            lodgement_office_date_v1: "递交办公室日期",
            lodgement_office_date_v2: "递交办公室日期",
            nationality: "国籍",
            nationality_v1: "国籍",
            office_code: "办公室代码",
            other: "其他文件",
            owner_border_pass_date: "边境通行证日期",
            owner_border_pass_v1: "车主边境通行证",
            owner_passport_number: "车主护照号码",
            owner_passport_v1: "车主护照",
            passport_expired_date: "护照到期日期",
            passport_image_back: "护照背面照片",
            passport_image_front: "护照正面照片",
            passport_issued_date: "护照签发日期",
            passport_number: "护照号码",
            passport_v1: "护照",
            plate_number: "车牌号",
            profile_address: "地址",
            profile_driving_license_image_back: "驾驶证背面照片",
            profile_driving_license_image_front: "驾驶证正面照片",
            profile_first_name: "名字",
            profile_gender: "性别",
            profile_identity_date: "身份证日期",
            profile_identity_date_expire: "身份证到期日期",
            profile_identity_image_back: "身份证背面照片",
            profile_identity_image_front: "身份证正面照片",
            profile_identity_number: "身份证号码",
            profile_last_name: "姓氏",
            profile_nationality: "国籍",
            profile_passport_image_back: "护照背面照片",
            profile_passport_image_front: "护照正面照片",
            register_type: "注册类型",
            registration_date_v1: "注册日期",
            registration_date_v2: "注册日期",
            registration_number: "注册号码",
            registration_number_v1: "注册号码",
            registration_number_v2: "注册号码",
            registration_type: "类型",
            registration_type_v1: "类型",
            registration_year_v1: "注册年份",
            registration_year_v2: "注册年份",
            request_change_description: "请求更改描述",
            request_change_description2: "请求更改描述",
            security_date: "担保日期",
            security_number: "收据号码",
            security_office: "担保办公室",
            security_serial: "担保序列号",
            steer: "方向盘",
            to_date: "到日期",
            type: "类型",
            vehicle_type: "类型",
            verify_amend_description: "描述",
            year: "年份"
        }
    }
}